import { render } from "./shift-modal.vue?vue&type=template&id=e4587346"
import script from "./shift-modal.vue?vue&type=script&lang=js"
export * from "./shift-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__